import store from "../../../../redux/store";
import { callAPi } from "../CallService";
import { checkNat } from "./natCheck";

let auth, turn_cred, fetch_turn_cred_type;
let config = {};

export const getIceServerCred = async () => {
  var iceServers = [];
  if (turn_cred && (fetch_turn_cred_type !== "swebrtc" || window.natServer === "symmetric")) {
    var webrtc_domain = auth.kamailio_domain;
    const response = await callAPi(
      "/newsr/sr_callcenter/get_turn_credential/",
      "GET"
    );
    if (response && response.data) {
      const turndata = response.data;
      config.turnusername = turndata.data.username;
      config.turnuserpass = turndata.data.password;
      config.turnttl = turndata.data.ttl;

      iceServers = [
        {
          urls: `turn:${webrtc_domain}:443?transport=tcp`,
          username: config.turnusername,
          credential: config.turnuserpass,
        },
        {
          urls: `turns:${webrtc_domain}:80?transport=tcp`,
          username: config.turnusername,
          credential: config.turnuserpass,
        },
        { urls: "stun:stun.l.google.com:19302" },
      ];
    }

    const interval = setInterval(function () {
      let currentepoctime = (Date.now() / 1000) | 0;
      if (!config.turnttl || config.turnttl <= currentepoctime) {
        window.iceServers = getIceServerCred()
      }
    }, 10000);

    // return { interval: interval, turn_check: true };
  } else {
    iceServers = [
      { urls: "stun:stun.l.google.com:19302" },
      { urls: "stun:stun1.l.google.com:19302" },
      { urls: "stun:stun2.l.google.com:19302" },
      { urls: "stun:stun3.l.google.com:19302" },
      { urls: "stun:stun4.l.google.com:19302" },
    ];
    // return { turn_check: false };
  }
  return iceServers;
};

export const initialize = async () => {
  auth = store.getState().auth;
  turn_cred = auth.profile ? auth.profile.fetch_turn_cred : false;
  fetch_turn_cred_type = auth.profile ? auth.profile.fetch_turn_cred_type : false;

  // getIceServerCred();
  if (fetch_turn_cred_type === "swebrtc") {
    await checkNat();
  }
  else {
    window.iceServers = await getIceServerCred();
  }
};
